class SearchModalRecommendations {
  constructor(detailsModal) {
    this.detailsModal = detailsModal;
    this.details = detailsModal.querySelector('details');
    this.container = detailsModal.querySelector('[data-search-modal-recommendations]');

    if (!this.details || !this.container) return;

    this.onToggle = this.onToggle.bind(this);
    this.details.addEventListener('toggle', this.onToggle);
  }

  async onToggle() {
    if (!this.details.open) return;
    if (this.container.getAttribute('data-cart-loaded') === 'true') return;

    const enableCart = String(this.container.getAttribute('data-cart-recommendations')) === 'true';
    if (!enableCart) return;

    const limit = Number(this.container.getAttribute('data-limit')) || 6;

    try {
      const cartRes = await fetch(`${routes.cart_url}.js`, { credentials: 'same-origin' });
      if (!cartRes.ok) return;
      const cart = await cartRes.json();
      const productId = cart?.items?.[0]?.product_id;
      if (!productId) return;

      const recUrl = `/recommendations/products?product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}&section_id=search-modal-recommendations`;
      const recRes = await fetch(recUrl, { credentials: 'same-origin' });
      if (!recRes.ok) return;
      const html = await recRes.text();
      const sectionEl = getDomHtmlFromText(html, '#shopify-section-search-modal-recommendations');
      const inner = sectionEl?.querySelector('[data-search-modal-recommendations-inner]');
      if (!inner) return;

      const target = this.container.querySelector('[data-search-modal-recommendations-inner]') || this.container;
      target.innerHTML = inner.innerHTML;
      this.container.setAttribute('data-cart-loaded', 'true');
    } catch (e) {
      return;
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('details-modal.header__search').forEach((el) => {
    new SearchModalRecommendations(el);
  });
});
